export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13418.25d05d18.jpg";